export const INITIAL_PAGE_NAME = '/home'
